import { shaderMaterial } from "@react-three/drei"
import * as THREE from "three"
import { extend } from "@react-three/fiber"

import raw from "raw.macro"

const gateFragmentShader = raw("./shaders/gate/fragment.glsl")
const gateVertexShader = raw("./shaders/gate/vertex.glsl")

const GateShaderMaterial = shaderMaterial(
    {
        uTime: 1,
        uBigWavesElevation: 0.2,
        uBigWavesSpeed: 0.4,
        uBigWavesFrequency: new THREE.Vector2(1, 1),
        uSmallWavesElevation: 0.05,
        uSmallWavesFrequency: 20,
        uSmallWavesSpeed: 1.5,
        uSmallWavesIteration: 1,
        uDepthColor: new THREE.Color("#1866aa"),
        uSurfaceColor: new THREE.Color("#9bd8ff"),
        // uDepthColor: new THREE.Color("#000"),
        // uSurfaceColor: new THREE.Color("#fff"),
        uColorOffset: -0.1,
        uColorMultiplier: 5,
    },
    // vertex shader
    `${gateVertexShader}
    varying vec2 uVu;
    void main(){
      vec4 modelPosition = modelMatrix * vec4(position, 1.0);
  
      vec2 wavedUv = vec2(
        uv.x + sin(uv.y * 100.0) * 0.1,
        uv.y + sin(uv.x * 100.0) * 0.1
      );
      // float strength = abs(distance(wavedUv, vec2(0.5)) - 0.25);
      float strength = 0.5 - distance(uv, vec2(0.5));
      vec2 offset = vec2(sin(uTime * 0.1), cos(uTime * 0.1));

      float elevation = 0.0;
      elevation += cnoise(vec3((uv.xy + offset) * uSmallWavesFrequency, uTime * uSmallWavesSpeed)) * strength;
      float finalElevation = elevation * (1.0 + abs(strength * uSmallWavesElevation));
      modelPosition.z += finalElevation + strength;
      
      vec4 viewPosition = viewMatrix * modelPosition;
      vec4 projectionPosition = projectionMatrix * viewPosition;
  
      gl_Position = projectionPosition;
  
      vElevation = finalElevation + strength;
      uVu = uv;
  }
    
    `,
    // fragment shader
    `${gateFragmentShader}
    varying vec2 uVu;
    void main() {
          float mixStrength = (vElevation + uColorOffset) * uColorMultiplier;
          vec3 color = mix(uDepthColor, uSurfaceColor, mixStrength);
          vec3 color2 = mix(uDepthColor, uSurfaceColor, mixStrength);
          vec3 uvColor = vec3(uVu, 0.5);
          gl_FragColor = vec4(color, 1.0);
  }
    `
)

extend({ GateShaderMaterial })
